import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { Button } from 'react-bootstrap';

export function Sandbox() {

    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const faPlusProp = faPlus as IconProp;

    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            <Button variant="contained" color="secondary" style={{ margin: "2px" }} onClick={() => setDialogOpen(true)}>Create</Button>
        </div>
    );
}